const getReturnUrl = (theapp) => {
	let start_conditions = theapp.getStartConditions();

	if (start_conditions.returnurl) {
		return start_conditions.returnurl; // was specified to the widget
	}
	else if (start_conditions.caller)
		return start_conditions.caller; // return to the caller (if instantiated programmatically via setStartConditions)
	else
		return theapp.getWidgetClientWindowUrl(); // current page of client if no info (e.g. when instantiated via the iframe's url)
}

export default getReturnUrl;